import React, {Fragment, useEffect, useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
// import CartaCiaTercero from './cartaCiaTercero'
import {useFormik} from 'formik'
import {
    configuracionFormAction16,
    obtenerDatosCartaCIATercero,
    obtenerComboTipoVehiculos,
    obtenerComboMarcas,
    obtenerComboCompanias,
    obtenerMontos
} from '../../../../store/actions/carta-cia-tercero-acttion'
import { Auth, LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import Antecedentes from './antecedentes'
import Acciones from './acciones'
import { validationSchemas } from '../../../../common/validation_Schemas-judicial'
import { limpiarRefAction, obtenerAntecedentesJudiciales, obtenerGrillaHistorialJudicial, postActualizarProcesoJudicial } from '../../../../store/actions/proceso-judicial-action'
import { obtenerDatosGestionImplicado } from '../../../../store/actions/proceso-extrajudicial-action'
// import Historial from './historial'
const AntecedentesJudicialModal = ({showAJudicial, handleCloseAJudicial}) => {
    const [loading, setLoading]=useState(false)  
    const [limpiarREF, setLimpiarREF]=useState(false)  
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_proceso_extrajudicial
    const [porcConvOldData, setPorcConvOldData] = useState('')
    const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
    const {montosInformados} = data_modal_cia
    const [isHito, setIsHito] = useState(false)
    const [isAudiencia, setIsAudiencia] = useState(false)
    const data_judicial = useSelector(
        (state) => state.procesoJudicialReducer
      )
      const { datosAntecedentesJudiciales, loadingJudicial} =
        data_judicial
    const [modedadata, setMonedaData] = useState('')
    const [showToast, setShowToast] = useState(false);

    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)
    const dispatch = useDispatch()
    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 16
        })).toString('base64')
        dispatch(configuracionFormAction16(query)).then(()=>setLoading(false))
    }, [dispatch])
 
       const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "instanciaJudicial": "",
            "competencia": "",
            "corte": "",
            "tribunal": "",
            "libro": "",
            "rol": "",
            "fechaIngresoCausa": "",
            "codHitoJudicial": "",
            "fechaHitoJudicial": "",
            "minutaHitoJudicial": "",
            "fechaAudiencia": "",
            "idUsuario": ""
        },
         validationSchema: validationSchemas(isHito,isAudiencia),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] = llaves && llaves['idUsuario']
           let idInstancia=0
           setLoading(true)
            if(datosAntecedentesJudiciales&& datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]!==undefined){

                 idInstancia=datosAntecedentesJudiciales &&
                datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idInstancia'] !== undefined &&
                datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idInstancia'] !== null &&
                datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idInstancia'] !== '' 
                ?datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idInstancia']
                :0
            }
            dataForm['instanciaJudicial'] = idInstancia
            setLoading(true)
        if(formData.file){
            getBase64(formData.file).then((base64data) => { 
                const fileData=base64data.split(',')[1]
              let data = { ...dataForm, "filename": formData.file.name, "mimetype": formData.file.type, "base64data": fileData };
              dispatch(postActualizarProcesoJudicial(data))
              .then(()=>GetHistorial()).then(()=>getAntecedentes())
              .then(()=>updateFormPrincipal())
              .then(()=>{
                dispatch(limpiarRefAction(true))
                formik.touched.file=false
              })
              .then(()=>{
                delete formData['file']
              })
              .then(()=>setLoading(false))
              handleShowToast()
            }) 
        }else{
            dispatch(postActualizarProcesoJudicial(dataForm))
              .then(()=>GetHistorial()).then(()=>getAntecedentes())
              .then(()=>updateFormPrincipal())
              .then(()=>setLoading(false))
              handleShowToast()
             
        } 


        }
    })
    const getAntecedentes=()=>{
        setLoading(true)
        if(llaves){

            let query = Buffer.from(
              JSON.stringify({"idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"]})
            ).toString('base64')
            dispatch(obtenerAntecedentesJudiciales(query)).then(()=>setLoading(false))
          }
    }
    const updateFormPrincipal=()=>{
        setLoading(true)
        if (llaves) {

            let query = Buffer.from(
              JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
            ).toString('base64')
            dispatch(obtenerDatosGestionImplicado(query)).then(()=>setLoading(false))
          }
    }
    const GetHistorial=()=>{
        setLoading(true)
        if(datosGestionImplicado && llaves){
      
          let query = Buffer.from(
            JSON.stringify({          
      
                "idCaso": llaves && llaves["idCaso"],
                 "idImplicado": llaves && llaves["idImplicado"],
                 "idModoIngreso1":238006, 
                "idModoIngreso2":null, 
                "tipoGestion": datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codTipoGestion"],
                 "ambitoGestion": datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]["codAmbitoGestion"],
                 "responsableReasignado": false  
              
           })
          ).toString('base64')
          dispatch(obtenerGrillaHistorialJudicial(query)).then(()=>setLoading(false))
        }
        
       }
    return (
        <>
        <LoadingComponent show={loading}/>
        <LoadingComponent show={loadingJudicial}/>
            <Modal show={showAJudicial}
                onHide={handleCloseAJudicial}
                size='xl'>
                <Form onSubmit={
                    formik.handleSubmit
                }>
                    <Antecedentes formik={formik}
                        setIsHito={setIsHito}
                        setIsAudiencia={setIsAudiencia}
                        setShowToast={setShowToast}
                        showToast={showToast}
                        
                        /> 
            <Acciones handleCloseAJudicial={handleCloseAJudicial}/>
                         </Form>
            </Modal>
        </>
    )
}

export default AntecedentesJudicialModal
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
  };